import React from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const ServicePage = () => {
  const { serviceListApi } = apiPath;
  const title = useParams();
  const [homeServiceUnique, homeServiceUniqueLoading] = useFetch(
    serviceListApi,
    false,
    title.title
  );

  if (homeServiceUniqueLoading) {
    return <Loading />;
  }

  const {
    fabImage,
    serviceTitle,
    serviceDesc,
    thumbnailImg,
    thumbnailText,
    accordionCardHeader,
    accordionCardPara,
    accordionData,
    url,
  } = homeServiceUnique;

  const data = [
    {
      elementType: "file",
      label: "Banner Image",
      type: "Text",
      name: "fabImage",
      defaultValue: fabImage,
      required: true,
    },
    {
      elementType: "textField",
      label: "Service Title",
      type: "Text",
      name: "serviceTitle",
      defaultValue: serviceTitle,
      fullCol: true,
      required: true,
    },
    {
      elementType: "textField",
      label: "Service Description",
      type: "Text",
      name: "serviceDesc",
      defaultValue: serviceDesc,
      fullCol: true,
      required: true,
    },
    {
      elementType: "file",
      label: "Thumbnail Image",
      type: "Text",
      name: "thumbnailImg",
      defaultValue: thumbnailImg,
      required: true,
    },
    {
      elementType: "textField",
      label: "Thumbnail Description",
      type: "Text",
      name: "thumbnailText",
      defaultValue: thumbnailText,
      fullCol: true,
      required: true,
    },
    {
      elementType: "textField",
      label: "Thumbnail url",
      type: "Text",
      name: "url",
      defaultValue: url,
      fullCol: true,
      required: true,
    },
    {
      elementType: "textField",
      label: "Accordion Card Header",
      type: "Text",
      name: "accordionCardHeader",
      defaultValue: accordionCardHeader,
      required: true,
      fullCol: true,
    },
    {
      elementType: "textField",
      label: "Accordion Card Description",
      type: "Text",
      name: "accordionCardPara",
      defaultValue: accordionCardPara,
      required: true,
      fullCol: true,
    },
  ];

  const accordionDataArr = [];
  accordionData.map((item, index) => {
    accordionDataArr.push({
      label: `Accordion data ${index}`,
      type: "text",
      name: "",
      defaultValue: item,
      required: false,
    });
  });

  const multiDimensionalDataText = [
    {
      elementType: "nestedTextService",
      label: "Accordion Data",
      name: "accordionData",
      multipleData: accordionDataArr,
      multiple: true,
      required: false,
      fullCol: true,
    },
  ];

  const useData = data.concat(multiDimensionalDataText);

  const update = (data) => {
    const newData = data.accordionData.map((item) => {
      const newObj = {};
      newObj.title = item[0];
      newObj.text = item[1];
      return newObj;
    });
    data.accordionData = newData;
    updateData(`${serviceListApi}/${title.title}`, data, true);
  };

  return (
    <div>
      <GlobalForm
        data={useData}
        multiDimensionalDataText={multiDimensionalDataText}
        update={update}
      />
    </div>
  );
};

export default ServicePage;
